module.exports = __webpack_public_path__ + "static/media/designPatent_30-1040123.d8c09d45.png";